<script setup>
/**
 * Card button base component
 * @displayName Card Button
 */

const props = defineProps({
  /**
   * Whether the button should be adjusted to the parent's width
   */
  fullWidth: {
    type: Boolean,
    required: false,
    default: false,
  },
});

const { handleKeyDown } = useAccessibility();
</script>

<template>
  <div class="card-btn-container">
    <a
      v-if="$attrs && $attrs.href"
      class="card-btn-content"
      :class="{ 'full-width': props.fullWidth }"
      :tabindex="0"
      :aria-label="$attrs['aria-label'] || 'Card button link'"
      v-bind="$attrs"
      @keydown="handleKeyDown"
    >
      <slot />
    </a>
    <button
      v-else
      type="button"
      class="card-btn-content"
      :class="{ 'full-width': props.fullWidth }"
      :tabindex="0"
      :aria-label="$attrs['aria-label'] || 'Card button'"
      v-bind="$attrs"
      @keydown="handleKeyDown"
    >
      <slot />
    </button>
  </div>
</template>

<style lang="scss" scoped>
.card-btn-container {
  font-family: $font-family-inter;

  a {
    text-decoration: none;
    color: $wds-color-ink-dark;
  }

  button {
    display: inline-block;
    appearance: none;
    background: none;
    border: none;
    padding: 0;
  }

  .card-btn-content {
    position: relative;
    display: inline-block;
    padding: wds-rem(14px) 1rem;
    background: $wds-color-white;
    border: 1px solid $wds-color-ink-dark;
    box-sizing: border-box;
    border-radius: $wds-border-radius-xl;
    cursor: pointer;
    text-align: center;
    outline: none;

    &.full-width {
      width: 100%;
    }

    &:hover {
      box-shadow: $wds-shadow-light-l;
    }

    &:focus {
      outline: none;
    }

    &:focus:not([disabled]) {
      box-shadow:
        0 0 0 wds-rem(2px) $wds-color-white,
        0 0 0 $wds-spacing-xs $wds-color-ink-darker;
    }
  }
}
</style>
